import { postNewGame } from '../api/postNewGame';

export const setPostNewGame = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            await postNewGame(params);
            if (callback) {
                alert('Сохранено')
                callback();
            }
        } catch (error) {
            alert('Ошибка')
            console.log(error)
        }
    }
}